import http from '../plugins/axios'

export const getAllCountryList = async (params) => {
  try {
    const response = await http.get(`/api/v2/country`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateCountry = async (id, payload) => {
  try {
    const response = await http.put(`/api/v2/country/${id}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getAllProvinceList = async (params) => {
  try {
    const response = await http.get(`/api/v2/provinces`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getAllCityList = async (params) => {
  try {
    const response = await http.get(`/api/v2/cities`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getAllDistrictList = async (params) => {
  try {
    const response = await http.get(`/api/v2/districts`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getProvinceById = async (id) => {
  try {
    const response = await http.get(`/api/v2/provinces/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getCityById = async (id) => {
  try {
    const response = await http.get(`/api/v2/cities/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getCountryPayments = async (params) => {
  try {
    const response = await http.get(`/api/v2/country-payments`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateCountryPayments = async (payload) => {
  try {
    const response = await http.post(`/api/v2/country-payments`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const createProvince = async (payload) => {
  try {
    const response = await http.post(`/api/v2/provinces`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateProvince = async (id, payload) => {
  try {
    const response = await http.put(`/api/v2/provinces/${id}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteProvince = async (id) => {
  try {
    const response = await http.delete(`/api/v2/provinces/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const createCity = async (payload) => {
  try {
    const response = await http.post(`/api/v2/cities`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateCity = async (id, payload) => {
  try {
    const response = await http.put(`/api/v2/cities/${id}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteCity = async (id) => {
  try {
    const response = await http.delete(`/api/v2/cities/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getAllPortList = async (params) => {
  try {
    const response = await http.get(`/api/v2/ports`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const createPort = async (payload) => {
  try {
    const response = await http.post(`/api/v2/ports`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updatePort = async (id, payload) => {
  try {
    const response = await http.put(`/api/v2/ports/${id}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deletePort = async (id) => {
  try {
    const response = await http.delete(`/api/v2/ports/${id}`)
    return response.data
  } catch (error) {
    throw error
  }
}